<form [formGroup]="formGroup">
	<div class="card-title-block-non-sticky">
		<div class="card-title-label"><span
				translate>ecall-off.personnalize-your-call-off-informations</span><span>&#58;</span></div>
	</div>
	<div class="copo-container card-block header-grid-container card-portal"
		[ngClass]="{ 'seven-columns': twoDates, 'six-columns': oneDate, 'five-columns': !twoDates && !oneDate }">
		<div class="card-header-double-span title" translate>ecall-off.call-off-header-information</div>
		<div class="card-column form-field-width">
			<mat-form-field floatLabel="always" subscriptSizing="dynamic">
				<mat-label translate>ecall-off.unloading-reference</mat-label>
				<input matInput formControlName="unloadingReference" type="text" spellcheck="false"
					autocomplete="off" maxlength="64">
				<mat-icon class="copo-orange-text-icon" matSuffix svgIcon="md:edit"></mat-icon>
			</mat-form-field>
		</div>
		<div *ngIf="shipToDetails && shipToDetails.length > 0 && allowChangeOfShipto">
			<mat-form-field floatLabel="always" subscriptSizing="dynamic">
				<mat-label translate>ecall-off.requested-ship-to</mat-label>
				<mat-select formControlName="shipTo" [compareWith]="compareShipTo">
					<mat-option *ngFor="let shipTo of shipToDetails" [value]="shipTo">
						<div class="copo-ship-to-name">{{shipTo.shipToDescription}}&nbsp;/&nbsp;{{shipTo.city}}</div>
						<div class="copo-ship-to-address">
							{{shipTo.address}} {{shipTo.postalCode}} {{shipTo.city}} ({{shipTo.country}})
						</div>
					</mat-option>
				</mat-select>
			</mat-form-field>
		</div>
		<div class="card-column form-field-width" *ngIf="oneDate">
			<mat-form-field floatLabel="always" subscriptSizing="dynamic">
				<mat-label translate>ecall-off.requested-date</mat-label>
				<input 	#startDateInput formControlName="requestedDate" matInput copoFormat="date"
						spellcheck="false" autocomplete="off" readonly
						[matDatepickerFilter]="dateFilter"
						[copoDatepicker]="requestedDatepicker" [min]="currentDate"
						(click)="requestedDatepicker.open()" (focus)="startDateInput.blur()">
				<mat-datepicker-toggle matSuffix class="copo-orange-text-icon" [for]="requestedDatepicker">
				</mat-datepicker-toggle>
				<mat-datepicker #requestedDatepicker [startAt]="currentDate">
				</mat-datepicker>
			</mat-form-field>
		</div>
		<div class="card-column form-field-width" *ngIf="twoDates">
			<mat-form-field floatLabel="always" subscriptSizing="dynamic">
			<mat-label translate>filter.number.from</mat-label>
			<input #startDateInput formControlName="fromDate" matInput copoFormat="date" spellcheck="false" autocomplete="off"
				readonly [copoDatepicker]="startDatepicker" [matDatepickerFilter]="dateFilter"
				[max]="getMaxFromDate()" (click)="startDatepicker.open()" (focus)="startDateInput.blur()" />
			<mat-datepicker-toggle matSuffix class="copo-orange-text-icon" [for]="startDatepicker">
			</mat-datepicker-toggle>
			<mat-datepicker #startDatepicker [startAt]="formGroup.get('fromDate')?.value">
			</mat-datepicker>
			</mat-form-field>
			</div>
			<div class="card-column form-field-width" *ngIf="twoDates">
				<mat-form-field floatLabel="always" subscriptSizing="dynamic">
					<mat-label translate>filter.date.to</mat-label>
					<input #endDateInput formControlName="toDate" matInput copoFormat="date" spellcheck="false" autocomplete="off"
						readonly [copoDatepicker]="endDatepicker" [matDatepickerFilter]="dateFilter"
						[min]="getMinToDate()" (click)="endDatepicker.open()" (focus)="endDateInput.blur()" />
					<mat-datepicker-toggle matSuffix class="copo-orange-text-icon" [for]="endDatepicker">
					</mat-datepicker-toggle>
					<mat-datepicker #endDatepicker [startAt]="formGroup.get('toDate')?.value">
					</mat-datepicker>
				</mat-form-field>
			</div>
		<div class="card-column alignment card-column-end">
			<a class="copo-orange-text-icon clickable" (click)="$event.preventDefault();onApplyAll()" href="#"><u
					translate>ecall-off.apply-for-all</u></a>
		</div>
	</div>
</form>